import { ModuleRegistry } from "ag-grid-community";
import { ClientSideRowModelModule } from "ag-grid-community";
import { LicenseManager } from "ag-grid-enterprise";
import { AllEnterpriseModule } from "ag-grid-enterprise";

// Initialize ag-grid
LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_KEY!);
// Register AG Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule, AllEnterpriseModule]);
